/**
 *
 * Tooltip
 *
 */

import React from 'react';
import {
  StyledTooltip,
  Text,
  Content,
} from './styledComponents'

const Tooltip = ({
  casing = "uppercase",
  offset,
  width,
  text,
  children,
  className,
  position,
  size,
  weight,
}) => (
  <StyledTooltip className={className} size={size} weight={weight}>
    <Text
      casing={casing}
      offset={offset}
      width={width}
      className={position}
    >
      {text}
    </Text>
    <Content>{children}</Content>
  </StyledTooltip>
);

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/Tooltip/index.js